<div class="info-page">
  <header class="info-hero about-hero">
    <img src="assets/Images/logo_b.png" alt="World of Webinars" class="about-logo" />
    <p class="info-kicker">Our story</p>
    <h1 class="info-heading">About W.O.W.</h1>
    <p class="info-sub">World of Webinars — product reviews with a lucky twist.</p>
  </header>

  <div class="info-highlights">
    <span class="info-chip">24 × 7</span>
    <span class="info-chip">Queue Automation</span>
    <span class="info-chip">Industry first</span>
  </div>

  <div class="info-grid info-grid--two">
    <article class="info-card">
      <h2 class="info-block-title"><span class="info-icon info-icon--gold">W</span> Who we are</h2>
      <p>World of Webinars, LLC is a startup virtual adventure allowing customers the ability to watch product reviews across an array of categories and consumer goods. Host product reviewers have the ability to leverage automation tools to provide a best-in-class product review experience to anyone in the world at any time of the day with new "Queue Automation".</p>
    </article>
    <article class="info-card">
      <h2 class="info-block-title"><span class="info-icon info-icon--teal">24</span> Always on</h2>
      <p>Our Website is available 24 x 7 from the comfort of your home, or on the go from your cell phone. LootLucky is a unique, Industry first product review site geared towards you!</p>
    </article>
  </div>

  <article class="info-card info-card--wide info-card--footer about-thanks">
    <img src="assets/Images/logo_b.png" alt="World of Webinars" class="about-thanks-logo" />
    <p><strong>Thanks for joining World of Webinars, <span class="wow-nowrap">W-O-W.!</span></strong></p>
    <a class="info-cta" routerLink="/HowItWorks">See how it works</a>
  </article>
</div>
